import React from 'react';
import { Typography } from '@mui/material';

interface HeaderProps extends React.ComponentProps<typeof Typography> {
  children: React.ReactNode;
  size: HeaderSize;
}
type HeaderSize = 'large' | 'medium' | 'small' | 'xsmall' | 'xxsmall';

const sizes: Record<HeaderSize, any> = {
  large: { color: '#1F2428', fontSize: '24px', fontWeight: 500, lineHeight: '36px' },
  medium: { color: '#1F2428', fontSize: '20px', fontWeight: 500, lineHeight: '30px' },
  small: { color: '#1F2428', fontSize: '18px', fontWeight: 500, lineHeight: '27px' },
  xsmall: { color: '#1F2428', fontSize: '16px', fontWeight: 400, lineHeight: '24px' },
  xxsmall: { color: '#1F2428', fontSize: '14px', fontWeight: 400, lineHeight: '21px' }
};

const Header = ({ children, size, ...props }: HeaderProps) => {
  const headerProps = sizes[size];
  return (
    <Typography {...headerProps} {...props}>
      {children}
    </Typography>
  );
};

export default Header;
